import '../node_modules/bootstrap/scss/bootstrap.scss' 
import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode'
import Viewer, { Worker } from '@phuocng/react-pdf-viewer';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import Carousel from 'react-bootstrap/Carousel';
import Velocity from 'velocity-animate';


// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import sostenibilidad from './img/sostenibilidad.png'
import './App.css';

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";


import logo from './img/productos/wallmix.png'

//
import c1 from './carousel/sostenibilidad/compromiso/1.jpg'
import c2 from './carousel/sostenibilidad/compromiso/2.jpg'
import c3 from './carousel/sostenibilidad/compromiso/3.jpg'


//
import pdfFileLocal from './fichas/Ficha Tecnica Wallmix.pdf'

function App() {

  let pdfFile = 'https://expo-melon.s3.amazonaws.com/fichas/Ficha Tecnica Wallmix.pdf';
  pdfFile = encodeURI(pdfFile);

  const slider1 = useRef();

  const [index, setIndex] = useState(0);

  let carousel = [
    c1,
    c2,
    c3
  ]  

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };  

  let [showQRModal, setShowQRModal] = useState(false);
  let [showPDFModal, setShowPDFModal] = useState(false);

  useEffect(() => {
    document.querySelector('.slider1-slides').innerHTML = parseInt(slider1.current.attributes['data-slides'].value);
    document.querySelector('.slider1-index').innerHTML = 1;
  }, [])

  useEffect(() => {

    if (document.getElementById('qr-canvas')) {
      QRCode.toCanvas(document.getElementById('qr-canvas'), pdfFile, {width: 600}, function (error) {
        if (error) console.error(error)
      });      
    }



  }, [showQRModal])

  const slideLeft = (slider) => {

    let index = parseInt(slider.current.attributes['data-index'].value);
    let slides = parseInt(slider.current.attributes['data-slides'].value);    

    if (index > 0) {
      Velocity(slider.current, {translateX: '+=100%'}, {duration: 250, complete: () => slider.current.setAttribute('data-index', index-1)});
      document.querySelector('.slider1-index').innerHTML = index;
    } else if (index==0) {
      // Velocity(slider.current, {translateX: '0%'}, {duration: 250, complete: () => slider.current.setAttribute('data-index', 0)});
    } 

  }

  const slideRight = (slider) => {

    let index = parseInt(slider.current.attributes['data-index'].value);
    let slides = parseInt(slider.current.attributes['data-slides'].value);

    if (index < slides-1) {
      Velocity(slider.current, {translateX: '-=100%'}, {duration: 250, complete: () => slider.current.setAttribute('data-index', index+1)});
      document.querySelector('.slider1-index').innerHTML = index+2;
      
    } else if (index==slides-1) {
      Velocity(slider.current, {translateX: '0%'}, {duration: 250, complete: () => slider.current.setAttribute('data-index', 0)});
      document.querySelector('.slider1-index').innerHTML = 1;
      
    }

  }


  return (
    <div className="App container-fluid g-0 fullvh">


    {showQRModal &&

      <div className="modal-container d-flex flex-column" onClick={() => setShowQRModal(false)}>
          <button style={{position: 'absolute', top: '5vh', left: '66vw', zIndex: 9}} className="nav-button" onClick={() => setShowQRModal(false)}><i className="fa-sharp fa-solid fa-close" data-fa-mask="fa-solid fa-comment"></i></button>
          <div className="modal-content d-flex flex-1 align-items-center justify-center">
            <div className="row">
              <div className="col">
                <div className="bg-white p-3">
                  <canvas id="qr-canvas" width="400" height="400"></canvas>                  
                </div>
              </div>
            </div>
          </div>
      </div>

    }

    {showPDFModal &&

      <div className="modal-container d-flex flex-column">
        <button style={{position: 'absolute', top: '0vh', left: '76.5vw', zIndex: 9}} className="nav-button" onClick={() => setShowPDFModal(false)}><i className="fa-sharp fa-solid fa-close" data-fa-mask="fa-solid fa-comment"></i></button>
        <div className="modal-content d-flex flex-1 align-items-center justify-center">
          <div className="row">
            <div className="col">
              <div className="bg-white p-3">
                <Worker workerUrl="/pdf.worker.min.js">
                    <div style={{ height: '100vh', width: '50vw' }}>
                        <Viewer fileUrl={pdfFileLocal} />
                    </div>
                </Worker>
              </div>
            </div>
          </div>
        </div>
      </div>

    }    

      <div className="row g-0">

        <img src={sostenibilidad} className="bg" />

        <div className="row g-0 fullvh">

          {/*<Breadcrumbs />*/}

          <div className="col-1 g-0">
            <Nav />
          </div>

          <div className=" col-11 d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col d-flex flex-column justify-center">

                <div className="row inner-board ps-5 pt-5 pb-5">

                  <Breadcrumbs />
                  
                  <div className="d-flex flex-row pb-3">
                    <div className="d-flex flex-column justify-center">
                      <h3 className="t-54 ps-3">Compromiso Ambiental</h3>
                      <h4 className="t-26 ps-3">Desempeño ambiental de excelencia para la construcción sostenible y resiliente</h4>
                    </div>
                    
                  </div>

                  <div className="col">

                    <div className="row">
                      <div className="col-6 d-flex flex-column">


                        <div className="product-left overflow-hidden d-flex flex-1">

                          <div ref={slider1} data-index="0" data-slides="2" className="product-left-slider d-flex flex-row align-items-center">
                           
                             <div className="product-left-slider-slide d-flex align-items-center justify-center">
                              
                              <div className="inner-description">

                                <p>Nos hemos propuesto poner en el centro de nuestra estrategia a la descarbonización y eficiencia en la producción, buscando impulsar el reemplazo de la matriz energética productiva y logística mediante la inversión en innovación para el rediseño del ciclo de vida de nuestros productos, y así enfocar nuestro negocio hacia la producción de sostenible con menor huella de carbono.</p>
  
                              </div>

                            </div> 

                            <div className="product-left-slider-slide d-flex align-items-center justify-center">
                              
                              <div className="inner-description-2">
                                <p>Iniciativas destacadas:</p>
                                <p>Descarbonización:</p>
                                <ul>
                                  <li>Definición de Estrategia y Hoja de Ruta</li>
                                  <li>Cuantificación del impacto ambiental de nuestros productos</li>
                                  <li>Reemplazo de matriz energética: coprocesamiento y uso de energías renovables</li>
                                </ul>
                                <p>Economía Circular</p>
                                <ul>
                                  <li>Uso y exploración de materias primas y combustibles alternativas</li>
                                  <li>Productos con enfoque en circularidad (saco soluble)</li>
                                </ul>
                                <p>Clientes</p>
                                <ul>
                                  <li>Desarrollo de cartera de productos con atributos sostenibles (Wallmix, Saco Soluble, Termomuro, Coppermix)</li>
                                </ul>
                                <p>Eficiencia hídrica</p>
                                <ul>
                                  <li>Sistemas de recuperación y recirculación de agua en la operación</li>
                                </ul>                                

                              </div>

                            </div>                                                        

                          </div>

                        </div>
                        <div className="product-left-pagination d-flex flex-row space-between">
                          <button className="inner-button" onClick={() => slideLeft(slider1)}><span><span className="chevron">&lt;</span></span></button>
                          <p ><span className="slider1-index"></span>/<span className="slider1-slides"></span></p>
                          <button className="inner-button" onClick={() => slideRight(slider1)}><span><span className="chevron">></span></span></button>
                        </div>

                      </div>
                      <div className="col-6 pe-6">
                        <div className="row d-flex flex-column">
                          <div className="col overflow-hidden">
                            <div className="product-carousel">
                              <Carousel variant="dark">
                              {carousel.map((imgsrc, index) => (
                                <Carousel.Item key={index}>
                                  <img
                                    className="d-block w-100"
                                    src={imgsrc}
                                  />
                                </Carousel.Item>
                                  )
                              )}
                              </Carousel>
                            </div>


                          </div>
                          <div className="col space-between d-flex pt-5 d-none">
                            
                            <button className="inner-button" onClick={() => setShowPDFModal(true)}><span>Ver ficha <span className="chevron">></span></span></button>

                            <button className="inner-button" onClick={() => setShowQRModal(true)}><span>Descargar ficha <span className="chevron">></span></span></button>


                          </div>
                        </div>
                        
                      </div>                      
                    </div>


                  </div>
                </div>
                
              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
